import { Popover } from 'antd';

import InputSelect from '@/components/inputSelect';

export default function NumberOfPurchases({
  productRecord,
  numberTipText,
  isShowNumberTip,
  productUnitInfo,
  setproductUnitInfo,
  setGdBuyNumber,
  setOverseaBuyNumber,
  overseaBuyNumber,
  gdBuyNumber,
}) {
  let localText = `最小起订量 ${productRecord.selfProductCode ? productRecord?.minBuyNumber : productRecord?.minBuyNumber * productRecord?.theRatio || 0} ${productRecord?.productUnit || productRecord?.unit || '个'}`;
  if (productRecord?.productMinEncapsulationUnit) {
    localText =
      `${productRecord?.productMinEncapsulationNumber}${productRecord?.productUnit || productRecord?.unit || '个'}/${productRecord?.productMinEncapsulationUnit}，` +
      localText;
  }
  const overseaText = `${productRecord?.minBuyNumber}${productRecord?.productUnit || productRecord?.unit || '个'}，最小起订量 ${productRecord?.minBuyNumber || 0} ${productRecord?.productUnit || productRecord?.unit || '个'}，递增量 ${productRecord?.incrementalQuantity || 0}`;
  const getInputForm = () => {
    if (productRecord?.isOversea) {
      return (
        <div className="mt-[8px] w-[330px]">
          <Popover content={numberTipText.overseaNumberTipText} open={isShowNumberTip.isShowOverseaNumberTip}>
            <InputSelect
              productRecord={productRecord}
              setValue={setOverseaBuyNumber}
              value={overseaBuyNumber}
              productUnit={productRecord?.unit}
              key="oversea"
              setproductUnit={(v) => {
                setproductUnitInfo({ ...productUnitInfo, gdProductUnit: v });
              }}
              inputWidth="330px"
            />
          </Popover>
        </div>
      );
    } else {
      return (
        <div className="mt-[16px]">
          <div className="w-[330px]">
            <Popover content={numberTipText.gdNumberTipText} open={isShowNumberTip.isShowGdNumberTip}>
              <InputSelect
                productRecord={productRecord}
                productUnit={productUnitInfo.gdProductUnit}
                key="gd"
                setValue={setGdBuyNumber}
                value={gdBuyNumber}
                disabled={productRecord?.productUnsealVendition == 'no'}
                setProductUnit={(v) => {
                  setproductUnitInfo({ ...productUnitInfo, gdProductUnit: v });
                }}
                inputWidth="330px"
              />
            </Popover>
          </div>
        </div>
      );
    }
  };

  return (
    <>
      <div className="flex items-center mt-[16px] w-[100%] text-[14px] not-italic text-[#020202]">
        <h3 className="font-bold">购买数量</h3>
        <span className="text-[#69788A] text-[12px] ml-[10px]">
          ({productRecord?.isOversea ? overseaText : localText})
        </span>
      </div>
      {getInputForm()}
      <div className="flex justify-between mt-[10px] text-[#54657D] text-[12px]">
        <span>
          起订量：
          {productRecord?.isOversea
            ? `${productRecord?.minBuyNumber || 0} ${productRecord?.productUnit || productRecord?.unit || '个'}`
            : `${productRecord.selfProductCode ? productRecord?.minBuyNumber : productRecord?.minBuyNumber * productRecord?.theRatio || 0} ${productRecord?.productUnit || productRecord?.unit || '个'}`}
        </span>
        {productRecord?.isOversea ? (
          <span>{`${productRecord?.minBuyNumber}${productRecord?.productUnit || productRecord?.unit || '个'}`}</span>
        ) : productRecord?.productMinEncapsulationUnit ? (
          <span>{`${productRecord?.productMinEncapsulationNumber}${productRecord?.productUnit || productRecord?.unit || '个'}/${productRecord?.productMinEncapsulationUnit}`}</span>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
